import { create } from "zustand";

export enum ErrorState {
    STATE_INITIAL = "",
    LIMIT_EXCEEDED_ERROR = "limit-exceeded",
    POST_SUSPENDED = "post-suspended",
    COMMENT_SUSPENDED = "comment-suspended",
    POST_NOT_FOUND = "post-not-found",
    USER_INACTIVE_OR_SUSPENDED = "user-inactive-or-suspended",
    AVATAR_GENERAL_ERROR = "avatar-general-error",
    NO_INTERNET = "no-internet-error",
    GENERAL_ERROR = "general-error",
}

interface ErrorSlice {
    errorState: ErrorState;
    setErrorState: (value: ErrorState) => void;
}

export const useErrorStore = create<ErrorSlice>()((set) => ({
    errorState: ErrorState.STATE_INITIAL,
    setErrorState: (newValue: ErrorState) =>
        set(() => ({ errorState: newValue })),
}));
